<script>
import { device } from '@/config/device'
// console.log(device)
let headerbarHeight = '45px'
switch (device.platform) {
  case 'android':
    headerbarHeight = '45px'
    break
  case 'ios':
    headerbarHeight = '65px'
    break
}
export default {
  name: 'page',
  props: {
    title: {
      default: '',
      type: String
    },
    menu: {
      default: '',
      type: String
    },
    // 在浏览器中,一般自带前进后退按钮,可能不需要导航栏
    headerBar: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      platform: device.platform ? 'page__' + device.platform : '',
      standalone: device.standalone,
      name: '' // 路由的名字,为了方便起见,直接使用$route.name
    }
  },
  computed: {
    headerbarHeight () {
      if (!this.headerBar) {
        return '0px'
      }
      return headerbarHeight
    }
  },
  methods: {
    back () {
      if (this.$route.name !== this.name) return
      const back = this.$listeners.back
      if (!back || (back && back() !== false)) {
        window.history.back()
      }
    }
  },
  mounted () {
    this.name = this.$route.name
    if (device.platform === 'android') {
      document.addEventListener('backbutton', this.back, false)
    }
  },
  destroyed () {
    if (device.platform === 'android') {
      document.removeEventListener('backbutton', this.back, false)
    }
  }
}
</script>

<template>
  <div class="page_container" :class="headerBar ? platform : ''">
    <template v-if="headerBar">
      <header class="page_header">
        <div class="page_back" @click="back">
          <i class="iconfont icondata_back" />
        </div>
        <div class="page_title">
          <slot name="title">
            <h1>{{title}}</h1>
          </slot>
        </div>
        <div class="page_menu">
          <slot name="menu">
            <span>{{menu}}</span>
          </slot>
        </div>
      </header>
      <div class="page_main" :style="{'padding-top': headerbarHeight }">
        <slot />
      </div>
    </template>
    <template v-else>
      <div class="page_main">
        <slot />
      </div>
    </template>
  </div>
</template>

<style lang="stylus">
// page结构
.page_container
  // min-height 100vh
  // height 100vh
  position relative

  // -webkit-overflow-scrolling touch
  /.page_header
    background-color #fff
    display flex
    justify-content space-between
    align-items center
    padding 0 16px
    height 45px
    line-bottom-1px()
    line-height 44px
    position fixed
    top 0
    left 0
    width 100%
    background-color #fff
    z-index 100

    /.page_back
      padding 0 16px
      margin-left -16px
      color #9b9b9b

      .iconfont
        font-size 20px

    /.page_title
      position absolute
      left 50%
      transform translateX(-50%)
      max-width 60%
      align-self center

      h1
        letter-spacing 0
        font-size 18px
        font-weight 600
        ellipsis()

    /.page_menu
      span
        margin-right 10px
        color $primary-color
        font-size 16px

  /.page_main
    // min-height 100%
    background-color $gray-100
    // padding-bottom 1px
    // margin-bottom -1px

.page__ios
  .page_header
    padding-top 20px
    height 65px

  .page_back, .page_menu
    padding-top 20px
    margin-top -20px

  .page_menu
    margin-right 10px

.page__android
  .page_header
    height 45px
</style>
